export const AUCTIONS_LOT_STATUS = {
    CANCELED: 'CANCELED',
    CLOSED: 'CLOSED',
    DELETED: 'DELETED',
    DRAFT: 'DRAFT',
    OPEN: 'OPEN',
    PAUSED: 'PAUSED',
    SCHEDULED: 'SCHEDULED',
} as const;
